export default __webpack_public_path__ + "55e6e51e747381a53613540bb4fb36ab.png";